import {createSelector} from 'reselect';
import _ from 'lodash';
import {baseMuiTheme} from 'module/Theme/BaseMuiTheme';
import {ThemeStateType} from 'module/Theme/reducer/ThemeReducerNS';
import {createTheme} from '@mui/material/styles';

export const selTheme = createSelector(
	(state: ThemeStateType) => state.Theme.global,
	(globalTheme) => {
		const t = createTheme(_.merge({}, baseMuiTheme, globalTheme));
		if (window.DEVELOPMENT) window.muiTheme = t;
		return t;
	},
)